import dayjs from 'dayjs';

export const dateToString = (date, withTime = false) => {
  if (withTime) {
    return dayjs(date).format('DD.MM.YYYY г. hh:ss');
  }
  return dayjs(date).format('DD.MM.YYYY') + ' г.';
};
